import { useQuery } from '@tanstack/react-query';
import { getMyOrganizations } from '@/app/services/organizationAccessService';

export const useOrganizationAccess = () => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['myOrganizations'],
    queryFn: getMyOrganizations,
    staleTime: 5 * 60 * 1000, // 5 minutes - orgs don't change often
  });

  return {
    organizations: data?.organizations ?? [],
    currentOrganizationId: data?.current_organization_id,
    primaryOrganizationId: data?.primary_organization_id,
    hasMultipleOrgs: (data?.organizations?.length ?? 0) > 1,
    isLoading,
    error,
    refetch,
  };
};
